import { ErrorAlert } from '@/ui/content';
import LinkWithQuery from '@/ui/content/LinkWithQuery';
import { RefObject } from 'react';
import { useMediaUnreachable } from './useMediaUnreachable';

export function MediaUnreachable() {
  const {
    loginReturnRef,
    linkExpiredText,
    loginText,
    orText,
    returnToHomepageText,
    isLoginButtonVisible,
    returnToHomepageRef,
    onLoginButtonClick,
  } = useMediaUnreachable();
  return (
    <div className="relative flex-grow flex">
      <ErrorAlert title="Nothing to see here" className="m-auto">
        <p>{linkExpiredText}.</p>
        <p>
          {isLoginButtonVisible && (
            <>
              <button
                className="text-primary-accent-100 underline"
                type="button"
                ref={loginReturnRef as RefObject<HTMLButtonElement>}
                onClick={onLoginButtonClick}
              >
                {loginText}
              </button>{' '}
              {orText}{' '}
            </>
          )}
          <LinkWithQuery path="/" ref={returnToHomepageRef}>
            <a className="R15 text-primary-accent-100 underline">
              {returnToHomepageText}
            </a>
          </LinkWithQuery>
        </p>
      </ErrorAlert>
    </div>
  );
}
